<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Edit Department</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="department.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="department.code" />
                                    <validation-error :errors="apiValidationErrors.code" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Short Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="department.short_name" />
                                    <validation-error :errors="apiValidationErrors.short_name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Port
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="department.port.id" name="port_id">
                                        <md-option
                                                v-for="port in available_ports"
                                                :key="port.id"
                                                :value="port.id"
                                        >
                                            {{ port.name + "( "+ port.code + ")" }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Department</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        department: {
            type: 'departments',
            name: null,
            short_name: null,
            code: null,
            port_id: null
        },
        available_ports: [],
        station_dropdown: [],
    }),
    created () {
        this.get();
        this.getCategories();
    },

    methods: {

        getCategories () {
            this.$store.dispatch('ports/list').then(() => {
                this.available_ports = this.$store.getters['ports/dropdown'];
                if (this.available_ports && this.available_ports.length) {
                    this.department.port_id = this.available_ports[0].id;
                }
            });
        },
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('departments/get', id);
                this.department = this.$store.getters['departments/department'];
                console.log(this.department);
                console.log('Welcome Home');
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            if (
                this.$isDemo == 1 &&
                    ['1'].includes(this.$route.params.id)
            ) {
                await this.$store.dispatch(
                    'alerts/error',
                    'You are not allowed to change data of default roles.'
                );
                return;
            }
            try {
                await this.$store.dispatch('departments/update', this.department);
                await this.$store.dispatch(
                    'alerts/success',
                    'Department updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'Departments List' });
        },
    },
};
</script>
